/**
 * Created by yuxin Wei on 2017/11/15.
 * 封装常量constants
 */
export default {
  //试卷分类
  paperCategory:{
    mockExam:{
      code:'1701',
      name:'模拟考试',
    },
    officiallyExam:{
      code:'1702',
      name:'历年真题'
    }
  },
  //考试类型
  examType:{
    task:'task',
    mock:'mock',
    plan:'plan'
  },
  //产品编码
  productTypeCode:{
    jkpt:'0701'
  },
  interfaceResult:{
    success:1,
    error:0,
    tokenfail:'SHD-0112',
    noRight:'QM-1003'//没有权限
  },
  // 试题包类型
  teachPackageType:{
    preparPackage:1901,//备课包
    testPackage:1902,// 随堂测试包
    homeworkPackage:1903// 课后练习包
  },
  //课后练习任务状态
  taskState:{
	'-1':'全部',
	'0':'待下发',
	'1':'进行中',
	'2':'已结束'
  },
  //资源包状态（发布/未发布）
  sourceState:{
    unpublished :2202,//未发布
    published:2201,      //发布资源
  },
  //成绩单相对路径
  scorelistpath:{
    path:'/jkpt/hy/tas/score_file/',
  }
}




// WEBPACK FOOTER //
// ./src/common/constants.js